import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// Boot-load apiClient so its global axios interceptor registers BEFORE
// any component-level `import axios from 'axios'` makes a request.
// This is what guarantees X-Site-Id is injected on every axios.* call,
// including legacy ComboV2 modules that import axios directly.
import "@/services/apiClient";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
